import { Box, Image, Theme, Typography } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { TrackedButton } from "@outschool/ui-components-shared";
import { SimpleRatings } from "@outschool/ui-components-website";
import { Carousel } from "@outschool/ui-legacy-component-library";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";
function EducatorCard({ educator }: { educator: Educator }) {
  const { t } = useTranslation("client\\components\\NewUserHome");
  const navigation = useNavigation();
  return (
    <Box
      sx={(theme: Theme) => ({
        maxWidth: "360px",
        width: "280px",
        [theme.breakpoints.down("sm")]: {
          minWidth: "300px"
        }
      })}
    >
      <Box
        sx={{
          borderRadius: "50%",
          overflow: "hidden",
          width: "252px",
          height: "252px",
          marginX: "auto",
          marginBottom: "1.5em"
        }}
      >
        <Image
          src={educator.profilePicture}
          alt={educator.name}
          width={252}
          height={252}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0.5em",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: "310px",
          textAlign: "center"
        }}
      >
        <Typography
          variant="h5"
          sx={{
            height: "6rem",
            alignItems: "center",
            display: "flex"
          }}
        >
          {educator.name}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={(theme: Theme) => ({ color: theme.palette.primary.main })}
        >
          {educator.title}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "row", gap: "0.5em" }}>
          <Typography variant="body1">
            <SimpleRatings
              starRating={educator.starRating || 0}
              reviewCount={educator.numRatings}
            />
          </Typography>
        </Box>
        <Typography variant="body1">{educator.description}</Typography>
        <Box>
          <TrackedButton
            variant="contained"
            sx={{ marginX: "auto", marginTop: "2rem" }}
            trackingName={"educator_profile_view"}
            onClick={() => {
              navigation(educator.teacherPageUrl, { hardNav: true });
            }}
          >
            <Trans t={t}>View Profile</Trans>
          </TrackedButton>
        </Box>
      </Box>
    </Box>
  );
}

type Educator = {
  name: string;
  profilePicture: string;
  title: string;
  description: string;
  starRating: number;
  numRatings: number;
  teacherPageUrl: string;
};

function HeroEducatorsComponent(props: {}, ref: React.Ref<any>) {
  const { t } = useTranslation("client\\components\\NewUserHome");
  const educators: Educator[] = [
    {
      name: "Chris Chien",
      profilePicture:
        "https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:252,width:252/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/3dbW9SOROCltOoCGrP2K",
      title: "Disney Designer",
      description:
        "A former theme park artist and designer, Mr. Chris helps kids dream big and express themselves.",
      starRating: 5.0,
      numRatings: 874,
      teacherPageUrl: "/teachers/7ea88293-0bb2-4f38-8302-3a098575f86f"
    },
    {
      name: "Chidumebi Ikechi Njoku-Browne",
      title: "Paleontologist & African History",
      description:
        "From fossils to folklore, Mr. Njoku-Browne brings unmatched energy and expertise to every lesson.",
      profilePicture:
        "https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:252,width:252/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/2pMDKzDSbapJ1YbdHB6T",
      starRating: 4.9,
      numRatings: 869,
      teacherPageUrl: "/teachers/Chidumebi-Ikechi-Njoku-Browne#usvra3uWeb"
    },
    {
      name: "Dr Pete",
      title: "Philosophy and Earth Sciences",
      description:
        "Dr. Pete keeps young minds engaged with thought experiments, media, and fun facts acraoss fields.",
      profilePicture:
        "https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:252,width:252/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/cPcfCQsUTPqeFo8MLkiA",
      starRating: 5.0,
      numRatings: 305,
      teacherPageUrl:
        "/search?userUid=b0efe528-96eb-45b5-bb9c-aa012db369d3&userName=Dr+Pete+PhD+Earth+Science+Philosophy+Geology&order=upcoming"
    },
    {
      name: "Miss Kate",
      title: "K-12 Special Ed & TEFL",
      description:
        "Miss Kate creates a safe environment for developing minds. Try to spot one of her cats, dogs, or rabbits!",
      profilePicture:
        "https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:252,width:252/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/C7np8pNxScuOqyY37HDv",
      starRating: 4.9,
      numRatings: 127,
      teacherPageUrl: "/teachers/Kathleen-Louise-Hooper"
    },
    {
      name: "Sarah Ponessa",
      title: "Orton-Gillingham Certified",
      description:
        "Miss Sarah tailors her classes for each learner to help them discover their passions and stay motivated",
      profilePicture:
        "https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:252,width:252/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/GsPvqLRASFuvsub2v2JG",
      starRating: 4.9,
      numRatings: 237,
      teacherPageUrl:
        "/classes/1-on-1-private-neurodivergent-tutoring-dyslexia-dysgraphia-delayed-learners-disVE4NX"
    },
    {
      name: "Kari Santos",
      title: "Stanford Engineer",
      description:
        "Teaching kids to code and become confident creators of technology (Scratch, micro:bit robotics)",
      profilePicture:
        "https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=fit:crop,height:252,width:252/output=quality:80,compress:true,strip:true,format:jpg/cache=expiry:max/https://cdn.filestackcontent.com/B1J4TUcnTbqIWLrFhCEp",
      starRating: 4.9,
      numRatings: 487,
      teacherPageUrl:
        "/classes/robotics-with-microbit-level-2-intro-to-yahboom-sensor-robot-kit-7DgiNgGs"
    }
  ];
  return (
    <Box
      ref={ref}
      sx={(theme: Theme) => ({
        maxWidth: "1120px",
        marginX: "auto",
        paddingY: "8em",
        [theme.breakpoints.down("md")]: {
          paddingY: "4em"
        }
      })}
    >
      <Box
        sx={{
          maxWidth: "750px",
          marginX: "auto",
          marginBottom: "3em",
          textAlign: "center"
        }}
      >
        <Typography variant="display2">
          <Trans t={t}>Real teachers, real connection, real progress</Trans>
        </Typography>
        <Box
          sx={(theme: Theme) => ({
            marginX: "auto",
            marginY: "1em",
            maxWidth: "504px",
            [theme.breakpoints.down("sm")]: { paddingX: "1em" }
          })}
        >
          <Typography variant="body1">
            <Trans t={t}>
              Learn from vetted teachers with real-world experience and academic
              expertise. With small, live classes and an average 5:1
              student-teacher ratio, your kid gets the attention and mentorship
              they need to thrive.
            </Trans>
          </Typography>
        </Box>
      </Box>
      <Carousel
        scrollOnMobile={true}
        arrowClickOnBox={true}
        sx={(theme: Theme) => ({
          overflow: "hidden",
          [theme.breakpoints.down("sm")]: {
            width: "300px",
            marginX: "auto"
          }
        })}
        arrowSx={{
          maskImage: "none",
          backgroundColor: "transparent",
          top: "-143px"
        }}
        rightArrowSx={{
          right: "-16px"
        }}
        leftArrowSx={{
          left: "-16px"
        }}
        scrollWidth={420}
      >
        <Box
          sx={(theme: Theme) => ({
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            flexWrap: "nowrap",
            overflow: "hidden",
            [theme.breakpoints.down("md")]: {
              marginLeft: "4rem"
            },
            [theme.breakpoints.down("sm")]: {
              margin: "0"
            }
          })}
        >
          {educators.map((educator, idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <EducatorCard educator={educator} />
              {idx !== educators.length - 1 && (
                <Box
                  sx={(theme: Theme) => ({
                    height: "100%",
                    borderRight: `1px solid ${theme.palette.neutral.light}`,
                    marginX: "4.3em",
                    [theme.breakpoints.down("sm")]: {
                      border: "none",
                      marginX: "6rem"
                    }
                  })}
                />
              )}
            </Box>
          ))}
        </Box>
      </Carousel>
    </Box>
  );
}

export const HeroEducators = React.forwardRef(HeroEducatorsComponent);
